import type { SupportTicketRow } from "@/api/client";
import {
  fmtTicketDate,
  inUserTab,
  USER_TABS,
  userRowSub,
  userTabCounts,
  type UserTab,
} from "./supportLogic";

// Левая колонка обычного окна: «Поддержка», «+ Новое обращение», вкладки с
// числами и свои обращения (эталон: .clist.sp-pg).

export function UserList({
  rows,
  failed,
  tab,
  onTab,
  selectedId,
  creating,
  onSelect,
  onNew,
  onRetry,
  onExit,
}: {
  /** null — ещё не пришли. */
  rows: SupportTicketRow[] | null;
  failed: boolean;
  tab: UserTab;
  onTab: (t: UserTab) => void;
  selectedId: string | null;
  creating: boolean;
  onSelect: (id: string) => void;
  onNew: () => void;
  onRetry: () => void;
  /** Закрыть окно: в узком окне, где виден только список, крестика переписки нет. */
  onExit: () => void;
}) {
  const all = rows ?? [];
  const counts = userTabCounts(all);
  const shown = all.filter((r) => inUserTab(r, tab));

  return (
    <div className="sup-list">
      <div className="sup-list-head">
        <b className="sup-title">Поддержка</b>
        <span className="sup-grow" />
        <button type="button" className="sup-primary" onClick={onNew}>
          + Новое обращение
        </button>
        <button type="button" className="sup-x sup-list-x" title="Закрыть" aria-label="Закрыть" onClick={onExit}>
          <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
            <path d="M4 4l8 8M12 4l-8 8" />
          </svg>
        </button>
      </div>
      <div className="sup-tabs" role="tablist">
        {USER_TABS.map((t) => (
          <button
            key={t.value}
            type="button"
            role="tab"
            aria-selected={tab === t.value}
            className={"sup-tab" + (tab === t.value ? " sup-tab--on" : "")}
            onClick={() => onTab(t.value)}
          >
            {t.label} {counts[t.value]}
          </button>
        ))}
      </div>
      <div className="sup-scroll">
        {shown.map((r) => (
          <button
            key={r.id}
            type="button"
            className={"sup-item" + (!creating && selectedId === r.id ? " sup-item--on" : "")}
            onClick={() => onSelect(r.id)}
          >
            <span className="sup-item-top">
              <span className="sup-item-name">{r.title}</span>
              <span className="sup-item-time">{fmtTicketDate(r.last_message_at)}</span>
            </span>
            <span className="sup-item-prev">
              <span className="sup-item-sub">{userRowSub(r)}</span>
              {r.unread > 0 && <span className="sup-unread">{r.unread}</span>}
            </span>
          </button>
        ))}
        {rows && !shown.length && (
          <div className="sup-empty">
            <b>Обращений нет</b>
          </div>
        )}
        {!rows && !failed && <div className="sup-empty">Загрузка…</div>}
        {failed && (
          <div className="sup-empty">
            <b>Не удалось загрузить обращения</b>
            <button type="button" onClick={onRetry}>
              Повторить
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
